
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transactions/tx",
      function () {
        return require("private-next-pages/transactions/tx.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transactions/tx"])
      });
    }
  